export const API_URL="https://mai.odasmali.com/api";
//export const API_URL="http://localhost:5000/api";
//export const URL_IMAGE="http://localhost:5000/media/";
export const URL_IMAGE="https://mai.odasmali.com/media/";